import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-air-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-cloud-windy-line' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-men-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-base-station-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-trophy-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-briefcase-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-links-line' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-contrast-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileCategoryOpen, setMobileCategoryOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      setMobileCategoryOpen(false);
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileMenuOpen]);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50">
      {/* Backdrop blur background layer - separated so it does not trap the fixed mobile menu */}
      <div className="absolute inset-0 bg-background-50/90 backdrop-blur-md"></div>

      <div className="w-full px-4 md:px-8 relative">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 shrink-0">
            <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
              <i className="ri-leaf-fill text-background-50 text-base"></i>
            </div>
            <span className="font-heading text-lg md:text-xl font-semibold text-foreground-900 whitespace-nowrap">
              Superbuy Spread Hub
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            <a href="/" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap font-medium">Home</a>

            {/* Category Dropdown */}
            <div ref={dropdownRef} className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-1.5 text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap font-medium cursor-pointer"
              >
                Categories
                <i className={`ri-arrow-down-s-line text-xs transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {dropdownOpen && (
                <div className="absolute top-full mt-2 left-0 bg-background-50 rounded-lg py-2 w-56 max-h-80 overflow-y-auto border border-background-200/70 shadow-lg">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a href="/superbuy-spreadsheet-guide" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap font-medium">Guide</a>
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap font-medium"
            >
              Superbuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden relative w-10 h-10 flex items-center justify-center text-foreground-900 cursor-pointer"
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          >
            <i className={`text-xl transition-transform duration-200 ${mobileMenuOpen ? 'ri-close-line rotate-90' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay - now fixed relative to viewport, not trapped inside nav */}
      {mobileMenuOpen && (
        <div className="md:hidden fixed top-16 left-0 right-0 bottom-0 bg-background-50 z-[60] overflow-y-auto">
          <div className="px-4 py-4 pb-24">

            {/* Quick Links */}
            <div className="flex items-center gap-3 mb-6">
              <button
                onClick={() => { navigate('/'); setMobileMenuOpen(false); }}
                className="flex-1 px-4 py-2.5 rounded-full bg-background-100 text-foreground-900 text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                <i className="ri-home-4-line mr-1.5"></i>
                Home
              </button>
              <button
                onClick={() => { navigate('/superbuy-spreadsheet-guide'); setMobileMenuOpen(false); }}
                className="flex-1 px-4 py-2.5 rounded-full bg-background-100 text-foreground-900 text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                <i className="ri-book-open-line mr-1.5"></i>
                Beginner Guide
              </button>
            </div>

            {/* Categories Section - expanded by default */}
            <div className="mb-6">
              <button
                onClick={() => setMobileCategoryOpen(!mobileCategoryOpen)}
                className="w-full flex items-center justify-between py-3 px-2 cursor-pointer"
              >
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-grid-line text-accent-600 text-sm"></i>
                  </div>
                  <span className="font-heading text-base font-semibold text-foreground-950">
                    Shop by Category
                  </span>
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-medium">
                    14
                  </span>
                </div>
                <i className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 ${mobileCategoryOpen ? 'rotate-180' : ''}`}></i>
              </button>

              <div className={`grid grid-cols-2 gap-1.5 mt-2 transition-all duration-300 ${mobileCategoryOpen ? 'opacity-100 max-h-[600px]' : 'opacity-0 max-h-0 overflow-hidden'}`}>
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMobileMenuOpen(false)}
                    className="flex items-center gap-2.5 px-3 py-3 rounded-lg hover:bg-background-100 active:bg-background-200 transition-colors cursor-pointer"
                  >
                    <div className="w-7 h-7 rounded-full bg-accent-100/70 flex items-center justify-center shrink-0">
                      <i className={`${cat.icon} text-accent-600 text-xs`}></i>
                    </div>
                    <span className="text-sm text-foreground-700 font-medium whitespace-nowrap truncate">{cat.name}</span>
                  </a>
                ))}
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-background-200 my-5"></div>

            {/* Guides Section */}
            <div className="mb-6">
              <div className="flex items-center gap-2 mb-3 px-2">
                <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-compass-3-line text-secondary-600 text-sm"></i>
                </div>
                <span className="font-heading text-base font-semibold text-foreground-950">Guides & Resources</span>
              </div>
              <div className="space-y-1">
                {[
                  { label: 'Complete Beginner Guide', icon: 'ri-book-open-line', slug: '/superbuy-spreadsheet-guide', color: 'text-accent-600', bg: 'bg-accent-100' },
                  { label: 'Safety & Trust Guide', icon: 'ri-shield-check-line', slug: '/superbuy-spreadsheet-safety-guide', color: 'text-primary-600', bg: 'bg-primary-100' },
                  { label: 'Shipping & Customs', icon: 'ri-ship-line', slug: '/superbuy-spreadsheet-shipping-guide', color: 'text-secondary-600', bg: 'bg-secondary-100' },
                  { label: 'All Categories Guide', icon: 'ri-grid-line', slug: '/superbuy-spreadsheet-categories', color: 'text-accent-600', bg: 'bg-accent-100' },
                ].map((item) => (
                  <button
                    key={item.slug}
                    onClick={() => { navigate(item.slug); setMobileMenuOpen(false); }}
                    className="w-full flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-background-100 active:bg-background-200 transition-colors cursor-pointer"
                  >
                    <div className={`w-7 h-7 rounded-full ${item.bg} flex items-center justify-center shrink-0`}>
                      <i className={`${item.icon} ${item.color} text-xs`}></i>
                    </div>
                    <span className="text-sm text-foreground-700 font-medium text-left">{item.label}</span>
                    <i className="ri-arrow-right-s-line text-foreground-400 ml-auto"></i>
                  </button>
                ))}
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-background-200 my-5"></div>

            {/* CTA Section */}
            <div className="space-y-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileMenuOpen(false)}
                className="w-full flex items-center justify-center gap-2 px-5 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer"
              >
                SUPERBUY SHEET
                <i className="ri-arrow-right-up-line text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileMenuOpen(false)}
                className="w-full flex items-center justify-center gap-2 px-5 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
              >
                BUY IT NOW
                <i className="ri-arrow-right-up-line text-sm"></i>
              </a>
            </div>

            {/* Footer Brand */}
            <div className="mt-8 pt-5 border-t border-background-200 text-center">
              <p className="text-xs text-foreground-400">Superbuy Spread Hub &copy; 2026</p>
              <p className="text-xs text-foreground-400/60 mt-1">The ultimate Superbuy Spreadsheet resource</p>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}